import { Loader2, ArrowDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface PullToRefreshIndicatorProps {
  pullDistance: number;
  refreshing: boolean;
  threshold: number;
}

export const PullToRefreshIndicator = ({
  pullDistance,
  refreshing,
  threshold,
}: PullToRefreshIndicatorProps) => {
  const visible = refreshing || pullDistance > 4;
  const ready = pullDistance >= threshold;
  const opacity = Math.min(1, pullDistance / threshold);
  const translate = Math.min(pullDistance, threshold + 10);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 top-0 z-[60] flex justify-center pointer-events-none"
      style={{
        transform: `translateY(${refreshing ? 12 : translate - 32}px)`,
        opacity: refreshing ? 1 : opacity,
        transition: refreshing ? "transform 200ms ease" : undefined,
      }}
    >
      <div className="rounded-full bg-card border border-border shadow-lg p-2">
        {refreshing ? (
          <Loader2 className="h-5 w-5 text-primary animate-spin" />
        ) : (
          <ArrowDown
            className={cn(
              "h-5 w-5 text-muted-foreground transition-transform",
              ready && "rotate-180 text-primary"
            )}
          />
        )}
      </div>
    </div>
  );
};
